import type { TimelineItem } from "@/types/news";

export default function EventTimeline({ items }: { items: TimelineItem[] }) {
  return (
    <ol className="relative mt-6 space-y-6 border-l border-background-300 pl-6">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <li key={`${item.time}-${item.title}`} className="relative">
            <span
              className={`absolute -left-[31px] top-1 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 ${
                isLast
                  ? "border-primary-500 bg-primary-500"
                  : "border-background-400 bg-background-50"
              }`}
            ></span>
            <div className="flex flex-wrap items-center gap-2">
              <time className="rounded-md bg-background-200 px-2 py-0.5 font-label-role text-xs font-medium text-foreground-700">
                {item.time}
              </time>
              <h4 className="font-heading text-sm font-semibold text-foreground-950">{item.title}</h4>
            </div>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </li>
        );
      })}
    </ol>
  );
}